module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1d.5b4e15ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-1d.svg
// module id = 512
// module chunks = 0